<template>
  <Button variant="destructive" @click.prevent="open = true">{{ $t('Assign to another model') }}</Button>
  <AssignToAnotherModel
    :open="open"
    @update:open="open = $event"
    :options="options"
    :action="action"
    :equipment-ids="equipmentIds"
  />
</template>
<script setup lang="ts">
import { ref } from 'vue'
import { Button } from "@/shadcn/components/ui/button";
import AssignToAnotherModel from "@/components/equipment/AssignToAnotherModel.vue";

defineProps<{
  options?: any[]
  action: string
  equipmentIds?: number[]
}>()

const open = ref(false)
</script>
